// Rank catalog for the /reach-out form: every enlisted, warrant, and
// officer paygrade for the four largest branches, keyed by branch so the
// form can ask Branch first and show only that branch's ranks. Values are
// the full human label ("Army · E-5 Sergeant") - that string is what lands
// on the lead, so it must read cleanly on the board.

const mk = (branch, list) =>
  list.map(([grade, title]) => {
    const label = `${grade} ${title}`;
    return { value: `${branch} · ${label}`, label };
  });

export const RANKS_BY_BRANCH = {
  'Army': mk('Army', [
    ['E-1', 'Private (PV1)'],
    ['E-2', 'Private (PV2)'],
    ['E-3', 'Private First Class'],
    ['E-4', 'Specialist / Corporal'],
    ['E-5', 'Sergeant'],
    ['E-6', 'Staff Sergeant'],
    ['E-7', 'Sergeant First Class'],
    ['E-8', 'Master Sergeant / First Sergeant'],
    ['E-9', 'Sergeant Major / Command Sergeant Major'],
    ['W-1', 'Warrant Officer 1'],
    ['W-2', 'Chief Warrant Officer 2'],
    ['W-3', 'Chief Warrant Officer 3'],
    ['W-4', 'Chief Warrant Officer 4'],
    ['W-5', 'Chief Warrant Officer 5'],
    ['O-1', 'Second Lieutenant'],
    ['O-2', 'First Lieutenant'],
    ['O-3', 'Captain'],
    ['O-4', 'Major'],
    ['O-5', 'Lieutenant Colonel'],
    ['O-6', 'Colonel'],
    ['O-7', 'Brigadier General'],
    ['O-8', 'Major General'],
    ['O-9', 'Lieutenant General'],
    ['O-10', 'General'],
  ]),
  'Air Force': mk('Air Force', [
    ['E-1', 'Airman Basic'],
    ['E-2', 'Airman'],
    ['E-3', 'Airman First Class'],
    ['E-4', 'Senior Airman'],
    ['E-5', 'Staff Sergeant'],
    ['E-6', 'Technical Sergeant'],
    ['E-7', 'Master Sergeant'],
    ['E-8', 'Senior Master Sergeant'],
    ['E-9', 'Chief Master Sergeant'],
    ['O-1', 'Second Lieutenant'],
    ['O-2', 'First Lieutenant'],
    ['O-3', 'Captain'],
    ['O-4', 'Major'],
    ['O-5', 'Lieutenant Colonel'],
    ['O-6', 'Colonel'],
    ['O-7', 'Brigadier General'],
    ['O-8', 'Major General'],
    ['O-9', 'Lieutenant General'],
    ['O-10', 'General'],
  ]),
  'Marine Corps': mk('Marine Corps', [
    ['E-1', 'Private'],
    ['E-2', 'Private First Class'],
    ['E-3', 'Lance Corporal'],
    ['E-4', 'Corporal'],
    ['E-5', 'Sergeant'],
    ['E-6', 'Staff Sergeant'],
    ['E-7', 'Gunnery Sergeant'],
    ['E-8', 'Master Sergeant / First Sergeant'],
    ['E-9', 'Master Gunnery Sergeant / Sergeant Major'],
    ['W-1', 'Warrant Officer 1'],
    ['W-2', 'Chief Warrant Officer 2'],
    ['W-3', 'Chief Warrant Officer 3'],
    ['W-4', 'Chief Warrant Officer 4'],
    ['W-5', 'Chief Warrant Officer 5'],
    ['O-1', 'Second Lieutenant'],
    ['O-2', 'First Lieutenant'],
    ['O-3', 'Captain'],
    ['O-4', 'Major'],
    ['O-5', 'Lieutenant Colonel'],
    ['O-6', 'Colonel'],
    ['O-7', 'Brigadier General'],
    ['O-8', 'Major General'],
    ['O-9', 'Lieutenant General'],
    ['O-10', 'General'],
  ]),
  'Space Force': mk('Space Force', [
    ['E-1', 'Specialist 1'],
    ['E-2', 'Specialist 2'],
    ['E-3', 'Specialist 3'],
    ['E-4', 'Specialist 4'],
    ['E-5', 'Sergeant'],
    ['E-6', 'Technical Sergeant'],
    ['E-7', 'Master Sergeant'],
    ['E-8', 'Senior Master Sergeant'],
    ['E-9', 'Chief Master Sergeant'],
    ['O-1', 'Second Lieutenant'],
    ['O-2', 'First Lieutenant'],
    ['O-3', 'Captain'],
    ['O-4', 'Major'],
    ['O-5', 'Lieutenant Colonel'],
    ['O-6', 'Colonel'],
    ['O-7', 'Brigadier General'],
    ['O-8', 'Major General'],
    ['O-9', 'Lieutenant General'],
    ['O-10', 'General'],
  ]),
  'Navy': mk('Navy', [
    ['E-1', 'Seaman Recruit'],
    ['E-2', 'Seaman Apprentice'],
    ['E-3', 'Seaman'],
    ['E-4', 'Petty Officer Third Class'],
    ['E-5', 'Petty Officer Second Class'],
    ['E-6', 'Petty Officer First Class'],
    ['E-7', 'Chief Petty Officer'],
    ['E-8', 'Senior Chief Petty Officer'],
    ['E-9', 'Master Chief Petty Officer'],
    ['W-2', 'Chief Warrant Officer 2'],
    ['W-3', 'Chief Warrant Officer 3'],
    ['W-4', 'Chief Warrant Officer 4'],
    ['W-5', 'Chief Warrant Officer 5'],
    ['O-1', 'Ensign'],
    ['O-2', 'Lieutenant Junior Grade'],
    ['O-3', 'Lieutenant'],
    ['O-4', 'Lieutenant Commander'],
    ['O-5', 'Commander'],
    ['O-6', 'Captain'],
    ['O-7', 'Rear Admiral (lower half)'],
    ['O-8', 'Rear Admiral'],
    ['O-9', 'Vice Admiral'],
    ['O-10', 'Admiral'],
  ]),
};

export const OTHER = '__other__';

// Branch question (asked before rank): the four largest branches + Other,
// which skips the rank list for a free-text entry.
export const BRANCH_OPTIONS = [
  ...Object.keys(RANKS_BY_BRANCH).map((b) => ({ value: b, label: b })),
  { value: OTHER, label: 'Other / not listed' },
];

// The chosen branch's ranks + an escape hatch for anything not listed.
export const rankOptionsForBranch = (branch) => [
  ...(RANKS_BY_BRANCH[branch] || []),
  { value: OTHER, label: 'Other / not listed' },
];
